import { render, staticRenderFns } from "./INDICE_BUSCA.vue?vue&type=template&id=215f1e33"
import script from "./INDICE_BUSCA.vue?vue&type=script&lang=js"
export * from "./INDICE_BUSCA.vue?vue&type=script&lang=js"
import style0 from "./INDICE_BUSCA.vue?vue&type=style&index=0&id=215f1e33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports